/**
 * KARVA Konfigurator-Extras (2026-10)
 *
 * Ergänzt den Halftone-Konfigurator, ohne halftone-customizer.js zu verändern:
 * - Schnellwahl-Größen passend zum Seitenverhältnis des Fotos (nach dem Upload)
 * - Hinweis "Zum gleichen Preis bis … möglich" innerhalb der aktuellen Preisstufe
 * - Regler für Kontrast/Helligkeit ausgeblendet, stattdessen Haken "Motiv von KARVA optimieren"
 *   (wird als Eigenschaft "Bildbearbeitung" an die Bestellung gehängt)
 * - Haken "Wandhalterung dazu": legt das Halterungs-Set zusätzlich in den Warenkorb
 * - Vorschau und Raumansicht zeigen den umlaufenden weißen Rand (9 mm) maßstabsgetreu
 * - Raumansicht: das Bild maßstabsgetreu an einer Wand (Raumfoto, Maßstab über die Person ~1,68 m)
 * - Sideboard-Ansicht: das Bild angelehnt auf einem 180 cm breiten Sideboard (Nahansicht, v. a. für kleine Formate)
 * - 3D-Ansicht: die 6 mm starke Platte leicht schräg von der Seite, per Ziehen drehbar
 *   (schwarzer Plattenkern, weiße Beschichtung oben, Kanten ca. 1 mm gefast)
 * - Lupe: Vorschau in voller Auflösung als Vollbild, zoombar (Mausrad, zwei Finger, Doppelklick)
 * - Raster wie im CNC-Programm (Halftoner): Linienabstand je nach Bildgröße 2,0 bis 3,2 mm,
 *   kräftigerer Kontrast und kaum Glättung entlang der Linien
 *   (der Abstand geht als Eigenschaft "Linienabstand" mit in die Bestellung)
 * - Hinweis unter der Größe: größere Abmessungen = mehr Detailtiefe (mit Linienanzahl)
 * - Eigenes Linienraster wie im Halftoner: durchgehende Linien, deren Breite sich entlang der
 *   Linie stufenlos ändert (RasterPro zeichnet nur einen Block pro Zelle). Wird nach jedem
 *   RasterPro-Durchlauf auf dessen Canvas gemalt, damit Vorschau, Lupe und Warenkorb-Bild passen.
 * - Beratungs-Box: "Unsicher? WhatsApp oder Kontaktformular" (WhatsApp mit vorausgefüllter Nachricht)
 *
 * Preisstufen kommen aus window.karvaTiers (siehe snippets/halftone_image.liquid).
 * Größenänderungen laufen über das normale "change"-Event der Eingabefelder,
 * damit Seitenverhältnis, Preis und Warenkorb-Werte vom Konfigurator selbst kommen.
 */
(function () {
  'use strict';

  var MIN_CM = 30;
  var MAX_LONG_CM = 120;
  var MAX_SHORT_CM = 80;
  var SHORT_SIDES = [30, 40, 50, 60, 80];

  function byId(id) { return document.getElementById(id); }

  function getTiers() {
    return (window.karvaTiers || []).slice().sort(function (a, b) { return a.max - b.max; });
  }

  function findTier(area) {
    var t = getTiers();
    for (var i = 0; i < t.length; i++) {
      if (area <= t[i].max + 0.0001) return t[i];
    }
    return t.length ? t[t.length - 1] : null;
  }

  function round1(n) { return Math.round(n * 10) / 10; }
  function floor1(n) { return Math.floor(n * 10) / 10; }
  function fmtCm(n) { return round1(n).toLocaleString('de-DE'); }
  function fmtPrice(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function withinLimits(w, h) {
    return Math.min(w, h) >= MIN_CM && Math.max(w, h) <= MAX_LONG_CM && Math.min(w, h) <= MAX_SHORT_CM;
  }

  function hasImage() {
    return !!document.querySelector('.halftone-image-placeholder.has-image');
  }

  function currentSize() {
    var w = parseFloat((byId('custom-width') || {}).value);
    var h = parseFloat((byId('custom-height') || {}).value);
    return (w > 0 && h > 0) ? { w: w, h: h } : null;
  }

  /** Setzt eine neue Größe. Die Breite löst das change-Event aus, der Konfigurator
   *  berechnet daraus die Höhe über das gesperrte Seitenverhältnis und den Preis. */
  function setSize(w, h) {
    var W = byId('custom-width');
    var H = byId('custom-height');
    if (!W || !H) return;
    W.value = w;
    H.value = h;
    W.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** Größte Größe mit Seitenverhältnis r, deren Fläche noch in die Stufe passt. */
  function largestInTier(r, maxArea) {
    var h = Math.sqrt(maxArea / r);
    var w = r * h;
    var s = 1;
    if (Math.max(w, h) > MAX_LONG_CM) s = Math.min(s, MAX_LONG_CM / Math.max(w, h));
    if (Math.min(w, h) > MAX_SHORT_CM) s = Math.min(s, MAX_SHORT_CM / Math.min(w, h));
    w = floor1(w * s);
    h = floor1(w / r);
    while (w * h > maxArea && w > MIN_CM) { w = round1(w - 0.1); h = floor1(w / r); }
    return { w: w, h: h };
  }

  /** Standard-Fotoformate je Seitenverhältnis [lange Seite, kurze Seite] in cm.
   *  Passt das Foto (Toleranz 1 %) zu keiner Reihe, gibt es keine Schnellwahl: dann Wunschformat. */
  var FAMILIES = [
    { r: 3 / 2, s: [[45, 30], [60, 40], [75, 50], [90, 60], [120, 80]] },
    { r: 4 / 3, s: [[40, 30], [60, 45], [80, 60], [100, 75]] },
    { r: 1, s: [[30, 30], [40, 40], [50, 50], [60, 60], [80, 80]] },
    { r: 16 / 9, s: [[53, 30], [71, 40], [89, 50], [107, 60]] },
    { r: 7 / 5, s: [[56, 40], [70, 50], [84, 60]] },
    { r: 5 / 4, s: [[50, 40], [75, 60], [100, 80]] }
  ];
  var RATIO_TOL = 0.01;

  function familyFor(r) {
    var q = r >= 1 ? r : 1 / r;
    for (var i = 0; i < FAMILIES.length; i++) {
      if (Math.abs(q / FAMILIES[i].r - 1) <= RATIO_TOL) return FAMILIES[i];
    }
    return null;
  }

  function presetSizes(r) {
    var f = familyFor(r);
    if (!f) return [];
    var list = [];
    f.s.forEach(function (d) {
      var w = r >= 1 ? d[0] : d[1], h = r >= 1 ? d[1] : d[0];
      if (withinLimits(w, h)) list.push({ w: w, h: h });
    });
    return list;
  }

  function sizeModule() {
    return document.querySelector('.halftone-right-section .halftone-module');
  }

  function renderPresets(size) {
    var box = byId('karva-size-presets');
    if (!box) return;
    var mod = sizeModule();
    if (!hasImage() || !size) {
      box.style.display = 'none';
      if (mod) mod.classList.remove('kv-has-presets', 'kv-wunsch');
      return;
    }

    var r = size.w / size.h;
    var key = r.toFixed(3);
    if (box.getAttribute('data-ratio') !== key) {
      var presets = presetSizes(r);
      var html;
      if (presets.length) {
        html = '<span class="karva-size-presets__label">Standardgrößen für dein Foto:</span>';
        presets.forEach(function (p) {
          var tier = findTier(p.w * p.h);
          html += '<button type="button" class="karva-size-preset" data-w="' + p.w + '" data-h="' + p.h + '">' +
            fmtCm(p.w) + ' × ' + fmtCm(p.h) + ' cm' +
            (tier ? '<span class="karva-size-preset__price">' + fmtPrice(tier.price) + '</span>' : '') +
            '</button>';
        });
        html += '<button type="button" class="karva-size-custom" data-kv-custom>Eigene Größe eingeben</button>';
      } else {
        html = '<p class="karva-size-wunsch"><strong>Wunschformat</strong> Dein Foto hat kein Standardformat. ' +
          'Gib Breite oder Höhe ein, die andere Seite passt sich deinem Foto automatisch an. Nichts wird abgeschnitten.</p>';
      }
      box.innerHTML = html;
      box.setAttribute('data-ratio', key);
      if (mod) {
        mod.classList.toggle('kv-has-presets', presets.length > 0);
        mod.classList.toggle('kv-wunsch', presets.length === 0);
      }
    }

    var buttons = box.querySelectorAll('.karva-size-preset');
    var anyActive = false;
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var active = Math.abs(parseFloat(b.getAttribute('data-w')) - size.w) < 1.2 &&
                   Math.abs(parseFloat(b.getAttribute('data-h')) - size.h) < 1.2;
      b.classList.toggle('is-active', active);
      if (active) anyActive = true;
    }
    var custom = box.querySelector('[data-kv-custom]');
    if (custom) custom.classList.toggle('is-active', !anyActive);
    box.style.display = 'flex';
  }

  function renderHint(size) {
    var hint = byId('karva-tier-hint');
    if (!hint) return;
    if (!hasImage() || !size) { hint.style.display = 'none'; return; }

    var tier = findTier(size.w * size.h);
    if (!tier) { hint.style.display = 'none'; return; }

    var best = largestInTier(size.w / size.h, tier.max);
    var gain = (best.w * best.h) / (size.w * size.h);
    if (gain > 1.05 && withinLimits(best.w, best.h)) {
      hint.innerHTML = 'Zum gleichen Preis bis <a href="#" class="karva-tier-hint__link" data-w="' + best.w +
        '" data-h="' + best.h + '">' + fmtCm(best.w) + ' × ' + fmtCm(best.h) + ' cm</a> möglich.';
      hint.style.display = 'block';
    } else {
      hint.style.display = 'none';
    }
  }

  /* ---------------- Hinweis Detailtiefe ---------------- */

  /** Anzahl der Fräslinien über das Motiv (Linien unter 30°, Fläche innerhalb des Randes). */
  function lineCount(size) {
    var w = size.w - 2 * BORDER_CM, h = size.h - 2 * BORDER_CM;
    var n = (w * 0.5 + h * 0.866) * 10 / spacingMm(size);
    return Math.round(n / 10) * 10;
  }

  /** Größtes erlaubtes Format im selben Seitenverhältnis. */
  function maxSizeFor(size) {
    var s = Math.min(MAX_LONG_CM / Math.max(size.w, size.h), MAX_SHORT_CM / Math.min(size.w, size.h));
    return { w: Math.min(round1(size.w * s), size.w >= size.h ? MAX_LONG_CM : MAX_SHORT_CM), h: Math.min(round1(size.h * s), size.h > size.w ? MAX_LONG_CM : MAX_SHORT_CM) };
  }

  function renderDetailHint(size) {
    var old = byId('karva-detail-hint');
    if (old) old.parentNode.removeChild(old);
    return;
  }
  function renderDetailHintAlt(size) {
    var hint = byId('karva-detail-hint');
    if (!hint) {
      var presets = byId('karva-size-presets');
      if (!presets) return;
      hint = document.createElement('div');
      hint.id = 'karva-detail-hint';
      hint.className = 'karva-detail-hint';
      presets.parentNode.insertBefore(hint, presets.nextSibling);
    }
    if (!hasImage() || !size) { hint.style.display = 'none'; return; }
    var html = '<strong>Größere Abmessungen = mehr Detailtiefe.</strong> ' +
      'In ' + fmtCm(size.w) + ' × ' + fmtCm(size.h) + ' cm entsteht dein Motiv aus rund ' + lineCount(size) + ' Fräslinien';
    var big = maxSizeFor(size);
    if (big.w * big.h > size.w * size.h * 1.15) {
      html += ', in ' + fmtCm(big.w) + ' × ' + fmtCm(big.h) + ' cm aus rund ' + lineCount(big) + '.';
    } else {
      html += '.';
    }
    hint.innerHTML = html;
    hint.style.display = 'block';
  }

  /* ---------------- Beratung: WhatsApp / Kontakt ---------------- */

  var WHATSAPP = '4917643460791';
  var CONTACT_URL = '/pages/individuelle-anfrage-1';

  function whatsappUrl() {
    var size = currentSize();
    var msg = 'Hallo KARVA, ich konfiguriere gerade ein gefrästes Bild' +
      (hasImage() && size ? ' (' + fmtCm(size.w) + ' × ' + fmtCm(size.h) + ' cm)' : '') +
      ' und bin mir unsicher. Könnt ihr mich beraten?';
    return 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(msg);
  }

  function setupHelp() {
    if (byId('karva-help')) return;
    // unter den Warenkorb-Button, damit der Kaufen-Knopf nicht nach unten rutscht
    var anchor = document.querySelector('.halftone-action-row') || document.querySelector('.halftone-pricing-section');
    if (!anchor) return;
    var box = document.createElement('div');
    box.id = 'karva-help';
    box.className = 'karva-help';
    box.innerHTML =
      '<p class="karva-help__text"><strong>Unsicher, ob dein Foto passt?</strong> ' +
      'Schreib uns, wir beraten dich persönlich und schauen uns dein Motiv gemeinsam an.</p>' +
      '<div class="karva-help__actions">' +
      '<a class="karva-help__btn karva-help__btn--wa" id="karva-help-wa" href="' + whatsappUrl() + '" target="_blank" rel="noopener">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.5-.3z"/></svg>' +
      'WhatsApp</a>' +
      '<a class="karva-help__btn" href="' + CONTACT_URL + '" target="_blank" rel="noopener">Kontaktformular</a>' +
      '</div>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    // Link beim Klick mit der aktuellen Größe aktualisieren
    var wa = byId('karva-help-wa');
    wa.addEventListener('click', function () { wa.href = whatsappUrl(); });
    fixHelpGap();
  }

  /** Die Button-Zeile hat (v. a. mobil) viel Innenabstand nach unten. Die Box rückt
   *  daher näher an den Warenkorb-Button; der Abstand wandert unter die Box. */
  function fixHelpGap() {
    var box = byId('karva-help'), row = document.querySelector('.halftone-action-row');
    if (!box || !row || box.previousElementSibling !== row) return;
    if (row.offsetParent === null) {   // Warenkorb-Zeile ausgeblendet (Schritt 1): normaler Abstand
      box.style.setProperty('margin-top', '16px', 'important');
      box.style.removeProperty('margin-bottom');
      return;
    }
    var pb = parseFloat(getComputedStyle(row).paddingBottom) || 0;
    var gap = parseFloat(getComputedStyle(row.parentNode).rowGap) || 0;
    var mt = Math.min(16, 16 - pb - gap);
    box.style.setProperty('margin-top', mt + 'px', 'important');
    box.style.setProperty('margin-bottom', Math.max(4, Math.min(pb, 32)) + 'px', 'important');
  }

  /* ---------------- Bildbearbeitung: Haken statt Regler ---------------- */

  var OPT_YES = 'Optimierung durch KARVA gewünscht';
  var OPT_NO = 'Wie in der Vorschau';

  function setupOptimizeChoice() {
    var sliders = document.querySelector('.halftone-sliders-row');
    if (sliders) sliders.style.display = 'none';
    if (byId('karva-optimize')) return;
    var pricing = document.querySelector('.halftone-pricing-section');
    if (!pricing) return;
    var box = document.createElement('label');
    box.className = 'karva-optimize';
    box.innerHTML =
      '<input type="checkbox" id="karva-optimize" checked>' +
      '<span><strong>Motiv vor dem Fräsen von uns optimieren lassen</strong>' +
      '<small>Wir prüfen dein Foto und passen Kontrast und Helligkeit für das beste Fräsergebnis an. ' +
      'Ohne Haken fräsen wir genau wie in der Vorschau.</small></span>';
    pricing.parentNode.insertBefore(box, pricing);
  }

  /* ---------------- Wandhalterung als Zusatz ---------------- */
  var MOUNT = null; // { id, price } aus /products/mounting-plates.js

  function setupMountChoice() {
    if (byId('karva-mount')) return;
    if (typeof fetch !== 'function') return;
    fetch('/products/mounting-plates.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod || !prod.variants || !prod.variants.length) return;
        var v = prod.variants[0];
        if (!v.available) return;
        MOUNT = { id: v.id, price: v.price };
        if (byId('karva-mount')) return;
        var anchor = byId('karva-optimize');
        anchor = anchor ? anchor.closest('label') : document.querySelector('.halftone-pricing-section');
        if (!anchor) return;
        var box = document.createElement('label');
        box.className = 'karva-optimize karva-mount';
        box.innerHTML =
          '<input type="checkbox" id="karva-mount">' +
          '<span><strong>Wandhalterung dazu (+' + fmtPrice(v.price) + ')</strong>' +
          '<small>Unsichtbares Halterungs-Set mit Puffern. Damit hängst du dein Bild ohne Rahmen direkt an die Wand.</small></span>';
        if (anchor.classList && anchor.classList.contains('karva-optimize')) {
          anchor.parentNode.insertBefore(box, anchor.nextSibling);
        } else {
          anchor.parentNode.insertBefore(box, anchor);
        }
      })
      .catch(function () {});
  }

  function mountWanted() {
    var cb = byId('karva-mount');
    return !!(cb && cb.checked && MOUNT);
  }

  function optimizeValue() {
    var cb = byId('karva-optimize');
    return (!cb || cb.checked) ? OPT_YES : OPT_NO;
  }

  // Auswahl an die Warenkorb-Anfrage des Konfigurators hängen (FormData, siehe halftone-customizer.js v4)
  (function wrapFetch() {
    var original = window.fetch;
    if (typeof original !== 'function') return;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof FormData !== 'undefined' &&
            init.body instanceof FormData && init.body.has('properties[_Render-Settings]')) {
          init.body.set('properties[Bildbearbeitung]', optimizeValue());
          init.body.set('properties[Linienabstand]', spacingMm(currentSize()).toLocaleString('de-DE', { minimumFractionDigits: 1 }) + ' mm');
          if (mountWanted()) {
            var qty = parseInt(init.body.get('quantity'), 10) || 1;
            var mountId = MOUNT.id;
            return original.apply(this, arguments).then(function (res) {
              if (!res || !res.ok) return res;
              return original.call(window, '/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: mountId, quantity: qty }] })
              }).then(function () { return res; }, function () { return res; });
            });
          }
        }
      } catch (e) { /* nie den Warenkorb blockieren */ }
      return original.apply(this, arguments);
    };
  })();

  /* ---------------- Raumansicht ---------------- */

  // Raumfoto (Shopify > Inhalte > Dateien). Maßstab aus der Person (~168 cm = ~825 px)
  var ROOM_PHOTO = 'https://cdn.shopify.com/s/files/1/0729/0391/7848/files/Gemini_Generated_Image_d20j2jd20j2jd20j.jpg?width=2000';
  var PHOTO_W = 2400;          // Pixel des Originalfotos
  var PHOTO_H = 1792;
  var PX_PER_CM = 7.8;         // Maßstab auf Wandebene (Person ~1,68 m vor der Wand, Sideboard ~77 cm)
  var CENTER_X = 780;          // Bildmitte horizontal (freie Wand links neben der Person)
  var FLOOR_Y = 1583;          // Wand-Boden-Kante
  var CENTER_HEIGHT_CM = 150;  // Bildmitte 1,50 m über dem Boden
  var roomMode = false;
  // Sideboard-Nahansicht (Shopify > Inhalte > Dateien). Maßstab über die Sideboard-Breite (180 cm = 1711 px)
  var SIDE_PHOTO = 'https://cdn.shopify.com/s/files/1/0729/0391/7848/files/karva-sideboard-nahansicht.jpg?v=1791470425&width=2000';
  var SIDE_W = 2184, SIDE_H = 1632;
  var SIDE_PX_PER_CM = 9.5;    // auf Höhe der Wand hinter dem Sideboard
  var SIDE_CENTER_X = 950;     // Mitte der freien Fläche links neben der Vase
  var SIDE_CONTACT_Y = 914;    // Auflagekante (Sideboard-Platte an der Wand)
  var SIDE_MAX_W = 90, SIDE_MAX_H = 70;  // größere Formate passen nicht sinnvoll aufs Sideboard
  var sideMode = false;
  var tdMode = false;
  var PLATE_CM = 0.6;          // Plattenstärke 6 mm
  var tdRot = { x: -10, y: -32 }; // Blickwinkel der 3D-Ansicht (Grad)

  /** Raum- und 3D-Snapshot nach einem neuen Rendern verwerfen. */
  function invalidateSnaps() {
    var r = byId('karva-room'); if (r) r.removeAttribute('data-src');
    var sd = byId('karva-side'); if (sd) sd.removeAttribute('data-src');
    var d = byId('karva-3d'); if (d) d.removeAttribute('data-src');
  }

  function findCanvas() {
    var wrap = byId('raster_pro_wrapper');
    if (!wrap) return null;
    var list = wrap.querySelectorAll('canvas');
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null && list[i].width > 1) return list[i];
    }
    return list[0] || null;
  }

  function snapshot() {
    var c = findCanvas();
    if (!c || c.width < 2) return null;
    var max = 900;
    var s = Math.min(1, max / Math.max(c.width, c.height));
    var t = withBorder(downscale(c, Math.round(c.width * s), Math.round(c.height * s)), currentSize());
    try { return t.toDataURL('image/jpeg', 0.85); } catch (e) { return null; }
  }

  /* ---------- Geglättete Bildschirm-Vorschau (gegen Moiré / "Kräuseln") ----------
   * RasterPro rendert in hoher Auflösung (z. B. 2400 px). Der Browser verkleinert
   * das Canvas beim Anzeigen ohne Filter -> die feinen Linien erzeugen Moiré.
   * Lösung: nach jedem Rendern eine sauber gefilterte Kopie in Bildschirmauflösung
   * darüberlegen. Das Original-Canvas (Export für den Warenkorb) bleibt unverändert. */
  function downscale(src, tw, th) {
    var cur = src, w = src.width, h = src.height;
    while (w / 2 >= tw && h / 2 >= th) {
      var t = document.createElement('canvas');
      t.width = Math.max(1, Math.round(w / 2));
      t.height = Math.max(1, Math.round(h / 2));
      var tx = t.getContext('2d');
      tx.imageSmoothingEnabled = true;
      tx.imageSmoothingQuality = 'high';
      tx.drawImage(cur, 0, 0, t.width, t.height);
      cur = t; w = t.width; h = t.height;
    }
    var o = document.createElement('canvas');
    o.width = Math.max(1, tw); o.height = Math.max(1, th);
    var ox = o.getContext('2d');
    ox.imageSmoothingEnabled = true;
    ox.imageSmoothingQuality = 'high';
    ox.drawImage(cur, 0, 0, o.width, o.height);
    return o;
  }

  /* Jedes Bild hat einen umlaufenden weißen Rand von 9 mm. Die Vorschau zeigt ihn
   * maßstabsgetreu zur gewählten Größe; das Motiv füllt die Fläche innerhalb des Randes. */
  var BORDER_CM = 0.9;
  var BEVEL_CM = 0.1;   // Fase 1 mm

  /* ---------- Raster-Einstellungen passend zur Fräse ----------
   * Abgeglichen mit dem Halftoner (Max Size ca. 1,06 × Spacing, Winkel -30°):
   * - Linienabstand wächst mit dem Bild: längste Seite 30 cm = 2,0 mm bis 120 cm = 3,2 mm
   *   (linear dazwischen). Größere Abstände = breitere Linien = satteres Schwarz.
   * - Kontrast 0,58 / Helligkeit 0,51: Lichter werden reinweiß, Tiefen satt schwarz
   * - Linien-Glättung 0,5 statt 3: Details entlang der Linie bleiben scharf */
  var SPACING_MIN_MM = 2.0, SPACING_MAX_MM = 3.2;

  /** Linienabstand in mm für eine Bildgröße (auf 0,1 mm gerundet, wie im Halftoner eingebbar). */
  function spacingMm(size) {
    if (!size) return SPACING_MIN_MM;
    var L = Math.max(size.w, size.h);
    var t = Math.max(0, Math.min(1, (L - MIN_CM) / (MAX_LONG_CM - MIN_CM)));
    return Math.round((SPACING_MIN_MM + t * (SPACING_MAX_MM - SPACING_MIN_MM)) * 10) / 10;
  }
  var RENDER = { contrast: 0.58, brightness: 0.51, lineSmoothing: 0.5 };
  // Eigenes Linienraster (abgeglichen mit Halftoner: Max Size 1,85 / Spacing 1,75 = 1,057)
  var LINES = { angleDeg: 30, maxRatio: 1.057, contrast: 0.53, brightness: 0.515 };

  /** Zeichnet das Motiv als durchgehende Linien mit stufenloser Breite. */
  function renderLines(src, W, H, sp) {
    var ang = LINES.angleDeg * Math.PI / 180, step = Math.max(0.75, sp / 4), cell = Math.max(1, sp / 2);
    var gw = Math.max(2, Math.round(W / cell)), gh = Math.max(2, Math.round(H / cell));
    var g = document.createElement('canvas'); g.width = gw; g.height = gh;
    var gx = g.getContext('2d'); gx.imageSmoothingEnabled = true; gx.imageSmoothingQuality = 'high';
    gx.fillStyle = '#fff'; gx.fillRect(0, 0, gw, gh); gx.drawImage(src, 0, 0, gw, gh);
    var px = gx.getImageData(0, 0, gw, gh).data, Lm = new Float32Array(gw * gh), sum = 0, i, j;
    for (i = 0, j = 0; i < Lm.length; i++, j += 4) { Lm[i] = (0.2126 * px[j] + 0.7152 * px[j + 1] + 0.0722 * px[j + 2]) / 255; sum += Lm[i]; }
    var mean = sum / Lm.length, kc = Math.tan(LINES.contrast * Math.PI / 2), kb = 2 * (LINES.brightness - 0.5);
    function lum(x, y) {
      var fx = x / cell - 0.5, fy = y / cell - 0.5;
      fx = fx < 0 ? 0 : fx > gw - 1 ? gw - 1 : fx; fy = fy < 0 ? 0 : fy > gh - 1 ? gh - 1 : fy;
      var x0 = fx | 0, y0 = fy | 0, x1 = Math.min(gw - 1, x0 + 1), y1 = Math.min(gh - 1, y0 + 1), ax = fx - x0, ay = fy - y0;
      var a = Lm[y0 * gw + x0] * (1 - ax) + Lm[y0 * gw + x1] * ax, c = Lm[y1 * gw + x0] * (1 - ax) + Lm[y1 * gw + x1] * ax;
      var v = kc * (a * (1 - ay) + c * ay - mean) + mean + kb;
      return v < 0 ? 0 : v > 1 ? 1 : v;
    }
    var out = document.createElement('canvas'); out.width = W; out.height = H;
    var o = out.getContext('2d'); o.fillStyle = '#fff'; o.fillRect(0, 0, W, H); o.fillStyle = '#000';
    var dx = Math.cos(ang), dy = Math.sin(ang), nx = -dy, ny = dx, maxW = sp * LINES.maxRatio;
    var nmin = Infinity, nmax = -Infinity, tmin = Infinity, tmax = -Infinity;
    [[0, 0], [W, 0], [0, H], [W, H]].forEach(function (p) {
      var n = p[0] * nx + p[1] * ny, t = p[0] * dx + p[1] * dy;
      nmin = Math.min(nmin, n); nmax = Math.max(nmax, n); tmin = Math.min(tmin, t); tmax = Math.max(tmax, t);
    });
    var top = [], bot = [];
    for (var n = nmin + sp / 2; n < nmax; n += sp) {
      top.length = 0; bot.length = 0;
      for (var t = tmin - step; t <= tmax + step; t += step) {
        var x = n * nx + t * dx, y = n * ny + t * dy;
        if (x < -sp || y < -sp || x > W + sp || y > H + sp) continue;
        var w = maxW * (1 - lum(x, y)) / 2;
        top.push(x + nx * w, y + ny * w); bot.push(x - nx * w, y - ny * w);
      }
      if (top.length < 4) continue;
      o.beginPath(); o.moveTo(top[0], top[1]);
      for (var q = 2; q < top.length; q += 2) o.lineTo(top[q], top[q + 1]);
      for (q = bot.length - 2; q >= 0; q -= 2) o.lineTo(bot[q], bot[q + 1]);
      o.closePath(); o.fill();
    }
    return out;
  }

  /** Nach jedem RasterPro-Durchlauf: dessen Canvas mit dem eigenen Linienraster übermalen. */
  function paintLines(hi) {
    try {
      var c = findCanvas(), src = hi.sourceImage, sp = targetDot();
      if (!c || !src || !sp || !hasImage() || c.width < 10 || !(src.width > 1)) return;
      var out = renderLines(src, c.width, c.height, sp);
      var x = c.getContext('2d');
      x.save();
      x.setTransform(1, 0, 0, 1, 0, 0);
      x.globalCompositeOperation = 'source-over';
      x.globalAlpha = 1;
      x.drawImage(out, 0, 0);
      x.restore();
    } catch (e) { /* dann bleibt das RasterPro-Bild stehen */ }
  }

  /** Linienabstand in Canvas-Pixeln für die aktuelle Größe (inkl. Verkleinerung durch den Rand). */
  function targetDot() {
    var hi = window.halftone_image, size = currentSize();
    if (!hi || !size) return null;
    var cw = hi.canvasWidth, ch = hi.canvasHeight;
    if (!(cw > 0) || !(ch > 0)) return null;
    var pxPerCm = Math.min(cw / size.w, ch / size.h);
    var sc = Math.max(1 - 2 * BORDER_CM / size.w, 1 - 2 * BORDER_CM / size.h);
    return Math.max(2, Math.round(spacingMm(size) / 10 * pxPerCm / sc * 100) / 100);
  }

  /** Setter von RasterPro so umlenken, dass immer die CNC-Werte gelten
   *  (der Konfigurator setzt sonst feste 8 px und Kontrast/Helligkeit 50 %). */
  function tuneRenderer(hi) {
    ['dotSize', 'contrast', 'brightness', 'lineSmoothing'].forEach(function (p) {
      var d = Object.getOwnPropertyDescriptor(hi, p);
      if (!d || !d.set || !d.get || !d.configurable) return;
      Object.defineProperty(hi, p, {
        configurable: true,
        enumerable: d.enumerable,
        get: d.get,
        set: function (v) {
          var want = p === 'dotSize' ? (targetDot() || v) : RENDER[p];
          if (Math.abs(d.get.call(this) - want) > 0.001) d.set.call(this, want);
        }
      });
    });
    hi.lineSmoothing = 0; hi.contrast = 0; hi.brightness = 0; // Werte werden durch RENDER ersetzt
    if (hasImage()) hi.dotSize = 0;                              // -> targetDot()
  }

  /** Nach Größenänderung: Linienabstand neu setzen (löst nur bei Änderung ein Rendern aus). */
  function applyDot() {
    var hi = window.halftone_image;
    if (hi && hi.__karvaTuned && hasImage()) hi.dotSize = 0;
  }
  function withBorder(src, size) {
    if (!size || !(size.w > 0) || !(size.h > 0)) return src;
    var W = src.width, H = src.height;
    var bx = Math.max(1, Math.round(BORDER_CM / size.w * W));
    var by = Math.max(1, Math.round(BORDER_CM / size.h * H));
    var iw = W - 2 * bx, ih = H - 2 * by;
    if (iw < 4 || ih < 4) return src;
    var o = document.createElement('canvas');
    o.width = W; o.height = H;
    var x = o.getContext('2d');
    x.fillStyle = '#ffffff';
    x.fillRect(0, 0, W, H);
    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    var sc = Math.max(iw / W, ih / H);
    var sw = iw / sc, sh = ih / sc;
    x.drawImage(src, (W - sw) / 2, (H - sh) / 2, sw, sh, bx, by, iw, ih);
    // 1-mm-Fase an der Vorderkante: legt den schwarzen Kern frei. Licht von links oben,
    // deshalb oben/links etwas heller als rechts/unten.
    var cx = Math.max(1, BEVEL_CM / size.w * W), cy = Math.max(1, BEVEL_CM / size.h * H);
    function quad(c, p) { x.fillStyle = c; x.beginPath(); x.moveTo(p[0], p[1]); x.lineTo(p[2], p[3]); x.lineTo(p[4], p[5]); x.lineTo(p[6], p[7]); x.closePath(); x.fill(); }
    quad('#4a4a4a', [0, 0, W, 0, W - cx, cy, cx, cy]);           // oben
    quad('#3a3a3a', [0, 0, cx, cy, cx, H - cy, 0, H]);           // links
    quad('#1e1e1e', [W, 0, W, H, W - cx, H - cy, W - cx, cy]);   // rechts
    quad('#141414', [0, H, cx, H - cy, W - cx, H - cy, W, H]);   // unten
    return o;
  }

  var smoothUrl = null, smoothTimer = null, smoothGen = 0;
  function smoothImg() {
    var img = byId('karva-smooth');
    if (!img) {
      var wrap = byId('raster_pro_wrapper');
      if (!wrap) return null;
      img = document.createElement('img');
      img.id = 'karva-smooth';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      wrap.appendChild(img);
    }
    return img;
  }
  function hideSmooth() {
    smoothGen++;
    var img = byId('karva-smooth');
    if (img) img.style.display = 'none';
  }
  /** Sichtbare Bildfläche des Canvas. Das Theme setzt object-fit: contain, dann
   *  liegt das Bild mit Rand im Canvas-Kasten (v. a. Hochformat auf dem Handy). */
  function contentRect(c) {
    var b = c.getBoundingClientRect();
    var fit = getComputedStyle(c).objectFit;
    if ((fit !== 'contain' && fit !== 'scale-down') || !c.height || !b.height) {
      return { left: b.left, top: b.top, width: b.width, height: b.height };
    }
    var ratio = c.width / c.height;
    var w = b.width, h = b.height;
    if (w / h > ratio) { w = h * ratio; } else { h = w / ratio; }
    return { left: b.left + (b.width - w) / 2, top: b.top + (b.height - h) / 2, width: w, height: h };
  }

  function updateSmooth() {
    var c = findCanvas();
    var wrap = byId('raster_pro_wrapper');
    if (!c || !wrap || c.width < 2 || !hasImage()) { hideSmooth(); return; }
    var r = contentRect(c);
    if (r.width < 10 || r.height < 10) { hideSmooth(); return; }
    var dpr = Math.min(3, window.devicePixelRatio || 1);
    var tw = Math.round(r.width * dpr), th = Math.round(r.height * dpr);
    var gen = ++smoothGen;
    var out;
    try { out = withBorder(downscale(c, tw, th), currentSize()); } catch (e) { hideSmooth(); return; }
    out.toBlob(function (blob) {
      if (!blob || gen !== smoothGen) return;
      var img = smoothImg();
      if (!img) return;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      var cr = contentRect(c), wr = wrap.getBoundingClientRect();
      if (smoothUrl) URL.revokeObjectURL(smoothUrl);
      smoothUrl = URL.createObjectURL(blob);
      img.src = smoothUrl;
      img.style.left = (cr.left - wr.left) + 'px';
      img.style.top = (cr.top - wr.top) + 'px';
      img.style.width = cr.width + 'px';
      img.style.height = cr.height + 'px';
      img.style.display = 'block';
    }, 'image/png');
  }
  function scheduleSmooth(delay) {
    clearTimeout(smoothTimer);
    smoothTimer = setTimeout(updateSmooth, delay || 0);
  }
  function hookRenderer() {
    var hi = window.halftone_image;
    if (!hi || typeof hi.clear !== 'function') { setTimeout(hookRenderer, 300); return; }
    if (hi.__karvaHooked) return;
    hi.__karvaHooked = true;
    var prevComplete = hi.onComplete;
    hi.onComplete = function () {
      paintLines(hi);
      if (typeof prevComplete === 'function') { try { prevComplete.apply(this, arguments); } catch (e) {} }
      scheduleSmooth(50);
      var room = byId('karva-room');
      if (room) { invalidateSnaps(); setTimeout(refresh, 60); }
    };
    var origClear = hi.clear;
    hi.clear = function () { clearTimeout(smoothTimer); hideSmooth(); return origClear.apply(this, arguments); };
    try { tuneRenderer(hi); hi.__karvaTuned = true; } catch (e) { /* Vorschau läuft dann mit Standardwerten */ }
    window.addEventListener('resize', function () { hideSmooth(); scheduleSmooth(400); setTimeout(refresh, 400); });
  }

  function setupRoomView() {
    var placeholder = document.querySelector('.halftone-image-placeholder');
    if (!placeholder || byId('karva-view-toggle')) return;

    var toggle = document.createElement('div');
    toggle.id = 'karva-view-toggle';
    toggle.className = 'karva-view-toggle';
    toggle.innerHTML =
      '<button type="button" data-view="preview" class="is-active">Vorschau</button>' +
      '<button type="button" data-view="3d">3D-Ansicht</button>' +
      '<button type="button" data-view="side">Auf dem Sideboard</button>' +
      '<button type="button" data-view="room">Im Raum ansehen</button>';
    var sizeModule = document.querySelector('.halftone-right-section .halftone-module');
    if (sizeModule) sizeModule.parentNode.insertBefore(toggle, sizeModule);
    else placeholder.parentNode.insertBefore(toggle, placeholder.nextSibling);

    var room = document.createElement('div');
    room.id = 'karva-room';
    room.className = 'karva-room';
    room.innerHTML =
      '<div class="karva-room__scene">' +
      '<img class="karva-room__bg" src="' + ROOM_PHOTO + '" alt="" aria-hidden="true">' +
      '<img class="karva-room__pic" alt="Dein Bild im Raum">' +
      '</div><div class="karva-room__caption"></div>';
    placeholder.appendChild(room);

    var side = document.createElement('div');
    side.id = 'karva-side';
    side.className = 'karva-room karva-side';
    side.innerHTML =
      '<div class="karva-room__scene" style="aspect-ratio:' + SIDE_W + '/' + SIDE_H + ';">' +
      '<img class="karva-room__bg" src="' + SIDE_PHOTO + '" alt="" aria-hidden="true">' +
      '<div class="karva-side__contact"></div>' +
      '<img class="karva-room__pic" alt="Dein Bild auf dem Sideboard">' +
      '</div><div class="karva-room__caption"></div>';
    placeholder.appendChild(side);
    setup3d(placeholder);
    setupZoom(placeholder);

    toggle.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-view]') : null;
      if (!b) return;
      var view = b.getAttribute('data-view');
      roomMode = view === 'room';
      tdMode = view === '3d';
      sideMode = view === 'side';
      var btns = toggle.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', btns[i] === b);
      invalidateSnaps();
      renderRoom(currentSize());
      renderSide(currentSize());
      render3d(currentSize());
      renderZoomBtn();
    });
  }

  function renderRoom(size) {
    var toggle = byId('karva-view-toggle');
    var room = byId('karva-room');
    if (!toggle || !room) return;
    var show = hasImage();
    toggle.style.display = show ? 'flex' : 'none';
    if (!show && (roomMode || tdMode || sideMode)) {
      roomMode = false;
      tdMode = false;
      sideMode = false;
      var first = toggle.querySelector('button');
      if (first) first.click();
      return;
    }
    room.style.display = (show && roomMode) ? 'flex' : 'none';
    if (!show || !roomMode || !size) return;

    var pic = room.querySelector('.karva-room__pic');
    var snapKey = size.w + 'x' + size.h;
    if (room.getAttribute('data-src') !== snapKey) {
      var src = snapshot();
      if (src) { pic.src = src; room.setAttribute('data-src', snapKey); }
    }
    var wPx = size.w * PX_PER_CM;
    var hPx = size.h * PX_PER_CM;
    // Das Raumfoto füllt die Szene per object-fit: cover. Position und Größe deshalb
    // über denselben Maßstab in Pixel umrechnen, sonst wird das Bild verzerrt.
    var scene = room.querySelector('.karva-room__scene');
    var sw = scene.clientWidth, sh = scene.clientHeight;
    if (!sw || !sh) { setTimeout(function () { renderRoom(currentSize()); }, 100); return; }
    var k = Math.max(sw / PHOTO_W, sh / PHOTO_H);
    var offX = (sw - PHOTO_W * k) / 2, offY = (sh - PHOTO_H * k) / 2;
    var visTop = -offY / k;
    var cy = FLOOR_Y - CENTER_HEIGHT_CM * PX_PER_CM;
    if (cy - hPx / 2 < visTop + 22) cy = visTop + hPx / 2 + 22; // sehr hohe Bilder nicht oben abschneiden
    pic.style.left = (offX + (CENTER_X - wPx / 2) * k) + 'px';
    pic.style.width = (wPx * k) + 'px';
    pic.style.top = (offY + (cy - hPx / 2) * k) + 'px';
    pic.style.height = (hPx * k) + 'px';
    // Schlagschatten nach rechts unten, passend zum Fensterlicht von links oben.
    // In Wand-Zentimetern angegeben, damit er mit der Bildgröße mitskaliert.
    var cm = PX_PER_CM * k;
    function shd(n) { return (n * cm).toFixed(1) + 'px'; }
    pic.style.boxShadow =
      shd(2.5) + ' ' + shd(3.5) + ' ' + shd(3) + ' rgba(45,28,12,.5),' +
      shd(6) + ' ' + shd(8) + ' ' + shd(10) + ' rgba(45,28,12,.28),' +
      shd(0.3) + ' ' + shd(0.4) + ' ' + shd(0.5) + ' rgba(0,0,0,.25)';
    room.querySelector('.karva-room__caption').textContent =
      fmtCm(size.w) + ' × ' + fmtCm(size.h) + ' cm – maßstabsgetreu (die Person ist ca. 1,68 m groß)';
  }

  function sideFits(size) { return !!size && size.w <= SIDE_MAX_W && size.h <= SIDE_MAX_H; }

  function renderSide(size) {
    var toggle = byId('karva-view-toggle');
    var side = byId('karva-side');
    if (!toggle || !side) return;
    var btn = toggle.querySelector('button[data-view="side"]');
    var fits = sideFits(size);
    if (btn) btn.style.display = fits ? '' : 'none';
    if (sideMode && size && !fits) {
      // Format zu groß fürs Sideboard: auf die Wandansicht wechseln
      var roomBtn = toggle.querySelector('button[data-view="room"]');
      if (roomBtn) { roomBtn.click(); return; }
    }
    var show = hasImage() && sideMode && !!size;
    side.style.display = show ? 'flex' : 'none';
    if (!show) return;

    var pic = side.querySelector('.karva-room__pic');
    var snapKey = size.w + 'x' + size.h;
    if (side.getAttribute('data-src') !== snapKey) {
      var src = snapshot();
      if (src) { pic.src = src; side.setAttribute('data-src', snapKey); }
    }
    var scene = side.querySelector('.karva-room__scene');
    var sw = scene.clientWidth, sh = scene.clientHeight;
    if (!sw || !sh) { setTimeout(function () { renderSide(currentSize()); }, 100); return; }
    var k = Math.max(sw / SIDE_W, sh / SIDE_H);
    var offX = (sw - SIDE_W * k) / 2, offY = (sh - SIDE_H * k) / 2;
    var wPx = size.w * SIDE_PX_PER_CM, hPx = size.h * SIDE_PX_PER_CM;
    var left = SIDE_CENTER_X - wPx / 2;
    if (left < 230) left = 230;                    // nicht über die linke Sideboard-Kante
    var top = SIDE_CONTACT_Y - hPx;
    pic.style.left = (offX + left * k) + 'px';
    pic.style.width = (wPx * k) + 'px';
    pic.style.top = (offY + top * k) + 'px';
    pic.style.height = (hPx * k) + 'px';
    // Angelehnt: oben minimal nach hinten gekippt, Schatten an der Wand nach rechts (Fensterlicht von links)
    pic.style.transformOrigin = '50% 100%';
    pic.style.transform = 'perspective(' + (1600 * k).toFixed(0) + 'px) rotateX(3deg)';
    var cm = SIDE_PX_PER_CM * k;
    function shd(n) { return (n * cm).toFixed(1) + 'px'; }
    pic.style.boxShadow =
      shd(1.5) + ' ' + shd(-0.5) + ' ' + shd(2.5) + ' rgba(60,40,20,.35),' +
      shd(4) + ' ' + shd(1) + ' ' + shd(8) + ' rgba(60,40,20,.22),' +
      shd(0.2) + ' ' + shd(0.3) + ' ' + shd(0.4) + ' rgba(0,0,0,.25)';
    // Kontaktschatten auf der Platte
    var ct = side.querySelector('.karva-side__contact');
    ct.style.left = (offX + (left - 1.5 * SIDE_PX_PER_CM) * k) + 'px';
    ct.style.width = ((wPx + 3 * SIDE_PX_PER_CM) * k) + 'px';
    ct.style.top = (offY + (SIDE_CONTACT_Y - 1.2 * SIDE_PX_PER_CM) * k) + 'px';
    ct.style.height = (2.4 * SIDE_PX_PER_CM * k) + 'px';
    side.querySelector('.karva-room__caption').textContent =
      fmtCm(size.w) + ' × ' + fmtCm(size.h) + ' cm – maßstabsgetreu auf einem 180 cm breiten Sideboard';
  }

  /* ---------------- 3D-Ansicht ---------------- */

  function setup3d(placeholder) {
    if (byId('karva-3d')) return;
    var d = document.createElement('div');
    d.id = 'karva-3d';
    d.className = 'karva-3d';
    d.innerHTML =
      '<div class="karva-3d__stage">' +
      '<div class="karva-3d__floor"></div>' +
      '<div class="karva-3d__obj">' +
      '<div class="karva-3d__face karva-3d__back"></div>' +
      '<div class="karva-3d__face karva-3d__side karva-3d__l"></div>' +
      '<div class="karva-3d__face karva-3d__side karva-3d__r"></div>' +
      '<div class="karva-3d__face karva-3d__side karva-3d__t"></div>' +
      '<div class="karva-3d__face karva-3d__side karva-3d__b"></div>' +
      '<div class="karva-3d__face karva-3d__front"><img alt="Dein Bild in der 3D-Ansicht"></div>' +
      '</div></div>' +
      '<div class="karva-3d__caption"></div>';
    placeholder.appendChild(d);

    // Ziehen dreht die Platte (horizontal immer, vertikal nur mit Maus)
    var stage = d.querySelector('.karva-3d__stage');
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, y: e.clientY, rx: tdRot.x, ry: tdRot.y, touch: e.pointerType === 'touch' };
      if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
      stage.classList.add('is-dragging');
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      tdRot.y = Math.max(-60, Math.min(60, drag.ry + (e.clientX - drag.x) * 0.35));
      if (!drag.touch) tdRot.x = Math.max(-30, Math.min(30, drag.rx - (e.clientY - drag.y) * 0.25));
      applyRot();
    });
    function end() { drag = null; stage.classList.remove('is-dragging'); }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function applyRot() {
    var obj = document.querySelector('#karva-3d .karva-3d__obj');
    if (obj) obj.style.transform = 'rotateX(' + tdRot.x.toFixed(1) + 'deg) rotateY(' + tdRot.y.toFixed(1) + 'deg)';
  }

  function render3d(size) {
    var d = byId('karva-3d');
    if (!d) return;
    var show = hasImage() && tdMode && !!size;
    d.style.display = show ? 'flex' : 'none';
    if (!show) return;

    var stage = d.querySelector('.karva-3d__stage');
    var sw = stage.clientWidth, sh = stage.clientHeight;
    if (!sw || !sh) { setTimeout(function () { render3d(currentSize()); }, 100); return; }

    var snapKey = size.w + 'x' + size.h;
    if (d.getAttribute('data-src') !== snapKey) {
      var src = snapshot();
      if (src) { d.querySelector('.karva-3d__front img').src = src; d.setAttribute('data-src', snapKey); }
    }

    // Größe so wählen, dass die gedrehte Platte sicher in die Bühne passt
    var s = Math.min(sw * 0.66 / size.w, sh * 0.7 / size.h); // px pro cm
    var W = size.w * s, H = size.h * s;
    var T = Math.max(2, PLATE_CM * s);

    var obj = d.querySelector('.karva-3d__obj');
    obj.style.width = W + 'px';
    obj.style.height = H + 'px';
    obj.style.left = (sw - W) / 2 + 'px';
    obj.style.top = (sh - H) / 2 + 'px';

    function face(sel, w, h, l, t, tf) {
      var f = obj.querySelector(sel);
      f.style.width = w + 'px'; f.style.height = h + 'px';
      f.style.left = l + 'px'; f.style.top = t + 'px';
      f.style.transform = tf;
    }
    face('.karva-3d__front', W, H, 0, 0, 'translateZ(' + T / 2 + 'px)');
    face('.karva-3d__back', W, H, 0, 0, 'rotateY(180deg) translateZ(' + T / 2 + 'px)');
    face('.karva-3d__r', T, H, (W - T) / 2, 0, 'rotateY(90deg) translateZ(' + W / 2 + 'px)');
    face('.karva-3d__l', T, H, (W - T) / 2, 0, 'rotateY(-90deg) translateZ(' + W / 2 + 'px)');
    face('.karva-3d__t', W, T, 0, (H - T) / 2, 'rotateX(90deg) translateZ(' + H / 2 + 'px)');
    face('.karva-3d__b', W, T, 0, (H - T) / 2, 'rotateX(-90deg) translateZ(' + H / 2 + 'px)');

    var floor = d.querySelector('.karva-3d__floor');
    floor.style.width = W * 0.9 + 'px';
    floor.style.left = (sw - W * 0.9) / 2 + 'px';
    floor.style.top = ((sh + H) / 2 + Math.min(40, sh * 0.06)) + 'px';
    applyRot();
    d.querySelector('.karva-3d__caption').textContent =
      fmtCm(size.w) + ' × ' + fmtCm(size.h) + ' cm, 6 mm stark – zum Drehen ziehen';
  }

  /* ---------------- Lupe / Vollbild-Zoom ---------------- */

  function setupZoom(placeholder) {
    if (byId('karva-zoom-btn')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.id = 'karva-zoom-btn';
    b.className = 'karva-zoom-btn';
    b.setAttribute('aria-label', 'Vorschau vergrößern');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/>' +
      '<path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Zoom</span>';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openZoom(); });
    placeholder.appendChild(b);
  }

  function renderZoomBtn() {
    var b = byId('karva-zoom-btn');
    if (b) b.style.display = (hasImage() && !roomMode && !tdMode && !sideMode) ? 'flex' : 'none';
  }

  function openZoom() {
    var c = findCanvas();
    if (!c || c.width < 2 || byId('karva-zoom')) return;
    var full;
    try { full = withBorder(c, currentSize()); } catch (e) { return; }
    full.toBlob(function (blob) {
      if (!blob) return;
      var url = URL.createObjectURL(blob);
      var ov = document.createElement('div');
      ov.id = 'karva-zoom';
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.setAttribute('aria-label', 'Vorschau vergrößert');
      ov.innerHTML =
        '<div class="kz-stage"><img alt="Vorschau in voller Auflösung" draggable="false"></div>' +
        '<button type="button" class="kz-close" aria-label="Schließen">×</button>' +
        '<div class="kz-bar"><button type="button" data-z="out" aria-label="Verkleinern">−</button>' +
        '<button type="button" data-z="fit">Ganzes Bild</button>' +
        '<button type="button" data-z="in" aria-label="Vergrößern">+</button></div>' +
        '<div class="kz-hint">Mausrad oder zwei Finger zum Zoomen · ziehen zum Verschieben</div>';
      // Im Konfigurator-Overlay einhängen, sonst liegt die Lupe dahinter (gleicher z-index)
      (byId('halftone-overlay-container') || document.body).appendChild(ov);
      var prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';

      var stage = ov.querySelector('.kz-stage');
      var img = ov.querySelector('img');
      var IW = full.width, IH = full.height;
      var s = 1, tx = 0, ty = 0, fit = 1, maxS = 1;

      function vw() { return stage.clientWidth; }
      function vh() { return stage.clientHeight; }
      function clampPan() {
        var w = IW * s, h = IH * s;
        tx = w <= vw() ? (vw() - w) / 2 : Math.min(0, Math.max(vw() - w, tx));
        ty = h <= vh() ? (vh() - h) / 2 : Math.min(0, Math.max(vh() - h, ty));
      }
      function apply() {
        clampPan();
        img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
        stage.classList.toggle('is-zoomed', s > fit * 1.02);
      }
      function zoomAt(ns, cx, cy) {
        ns = Math.max(fit, Math.min(maxS, ns));
        tx = cx - (cx - tx) * (ns / s);
        ty = cy - (cy - ty) * (ns / s);
        s = ns;
        apply();
      }
      function layout() {
        fit = Math.min(vw() * 0.94 / IW, vh() * 0.94 / IH);
        maxS = Math.max(fit * 1.5, 1.5 / Math.min(2, window.devicePixelRatio || 1));
        s = fit; tx = 0; ty = 0;
        apply();
      }

      img.onload = layout;
      img.src = url;

      stage.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = stage.getBoundingClientRect();
        zoomAt(s * Math.exp(-e.deltaY * 0.0015), e.clientX - r.left, e.clientY - r.top);
      }, { passive: false });

      var pts = {}, last = null;
      function ptList() { return Object.keys(pts).map(function (k) { return pts[k]; }); }
      function snapshotPts() {
        var l = ptList(), r = stage.getBoundingClientRect();
        if (l.length >= 2) {
          var dx = l[0].x - l[1].x, dy = l[0].y - l[1].y;
          last = { n: 2, d: Math.sqrt(dx * dx + dy * dy), mx: (l[0].x + l[1].x) / 2 - r.left, my: (l[0].y + l[1].y) / 2 - r.top };
        } else if (l.length === 1) {
          last = { n: 1, x: l[0].x, y: l[0].y };
        } else { last = null; }
      }
      stage.addEventListener('pointerdown', function (e) {
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        snapshotPts();
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var prev = last;
        snapshotPts();
        if (!prev || !last || prev.n !== last.n) return;
        if (last.n === 2) {
          if (prev.d > 0) zoomAt(s * (last.d / prev.d), last.mx, last.my);
          tx += last.mx - prev.mx; ty += last.my - prev.my; apply();
        } else {
          tx += last.x - prev.x; ty += last.y - prev.y; apply();
        }
      });
      function up(e) { delete pts[e.pointerId]; snapshotPts(); }
      stage.addEventListener('pointerup', up);
      stage.addEventListener('pointercancel', up);
      stage.addEventListener('dblclick', function (e) {
        var r = stage.getBoundingClientRect();
        if (s > fit * 1.05) { s = fit; apply(); } else { zoomAt(maxS, e.clientX - r.left, e.clientY - r.top); }
      });

      ov.querySelector('.kz-bar').addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('button[data-z]') : null;
        if (!t) return;
        var z = t.getAttribute('data-z');
        if (z === 'fit') { s = fit; apply(); return; }
        zoomAt(s * (z === 'in' ? 1.6 : 1 / 1.6), vw() / 2, vh() / 2);
      });

      function close() {
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', layout);
        document.documentElement.style.overflow = prevOverflow;
        if (ov.parentNode) ov.parentNode.removeChild(ov);
        URL.revokeObjectURL(url);
        var btn = byId('karva-zoom-btn'); if (btn) btn.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        else if (e.key === '+' || e.key === '=') zoomAt(s * 1.6, vw() / 2, vh() / 2);
        else if (e.key === '-') zoomAt(s / 1.6, vw() / 2, vh() / 2);
      }
      ov.querySelector('.kz-close').addEventListener('click', close);
      document.addEventListener('keydown', onKey);
      window.addEventListener('resize', layout);
      ov.querySelector('.kz-close').focus();
    }, 'image/png');
  }

  function injectStyles() {
    if (byId('karva-extras-style')) return;
    var css =
      '#karva-smooth{position:absolute;display:none;pointer-events:none;max-width:none!important;margin:0;padding:0;z-index:1;box-shadow:0 1px 3px rgba(0,0,0,.12),0 4px 14px rgba(0,0,0,.10);}' +
      '.karva-optimize{display:flex;gap:10px;align-items:flex-start;margin:16px 0 4px;padding:12px 14px;' +
      'border:1px solid #d6d1c8;border-radius:6px;background:#fff;cursor:pointer;font-size:14px;line-height:1.45;}' +
      '.karva-optimize input[type=checkbox]{-webkit-appearance:none!important;appearance:none!important;display:block!important;' +
      'width:20px!important;height:20px!important;min-width:20px;margin:1px 0 0!important;padding:0!important;flex:0 0 auto;' +
      'border:2px solid #202020!important;border-radius:4px!important;background:#fff!important;box-shadow:none!important;cursor:pointer;position:relative;opacity:1!important;}' +
      '.karva-optimize input[type=checkbox]::before,.karva-optimize input[type=checkbox]::after{content:none!important;display:none!important;}' +
      '.karva-optimize input[type=checkbox]:checked{background:#202020 url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M3 8.5l3.2 3L13 4.5%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/14px 14px no-repeat!important;}' +
      '.karva-optimize input[type=checkbox]:focus-visible{outline:2px solid #c9a24a;outline-offset:2px;}' +
      '.karva-optimize small{display:block;margin-top:4px;font-size:12.5px;color:#555;}' +
      '.karva-view-toggle{display:none;gap:0;margin:0 0 16px;border:1px solid #202020;border-radius:6px;overflow:hidden;width:max-content;}' +
      '.karva-view-toggle button{padding:8px 14px;border:0;background:#fff;color:#202020;font-size:13px;cursor:pointer;}' +
      '.karva-view-toggle button.is-active{background:#202020;color:#fff;}' +
      '.halftone-image-placeholder{position:relative;}' +
      '.karva-room{display:none;position:absolute;inset:0;z-index:50;flex-direction:column;align-items:center;' +
      'justify-content:center;gap:8px;background:#efefef;padding:12px;}' +
      '.karva-room__scene{position:relative;width:100%;max-height:100%;aspect-ratio:2400/1792;overflow:hidden;border-radius:4px;background:#e9e3da;}' +
      '.karva-room__bg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}' +
      '.karva-room__pic{position:absolute;object-fit:fill;background:#fff;}' +
      '.karva-side__contact{position:absolute;border-radius:50%;background:radial-gradient(ellipse at center,rgba(40,25,10,.38) 0%,rgba(40,25,10,0) 70%);filter:blur(2px);pointer-events:none;}' +
      '.karva-3d{display:none;position:absolute;inset:0;z-index:50;flex-direction:column;align-items:center;' +
      'justify-content:center;gap:8px;background:radial-gradient(ellipse at 50% 40%,#fafafa 0%,#e6e4e0 100%);padding:12px;}' +
      '.karva-3d__stage{position:relative;width:100%;flex:1 1 auto;min-height:0;perspective:1400px;perspective-origin:50% 45%;cursor:grab;touch-action:pan-y;user-select:none;-webkit-user-select:none;}' +
      '.karva-3d__stage.is-dragging{cursor:grabbing;}' +
      '.karva-3d__floor{position:absolute;height:22px;border-radius:50%;background:radial-gradient(ellipse at center,rgba(0,0,0,.28) 0%,rgba(0,0,0,0) 70%);filter:blur(4px);pointer-events:none;}' +
      '.karva-3d__obj{position:absolute;transform-style:preserve-3d;transition:transform .15s ease-out;}' +
      '.karva-3d__stage.is-dragging .karva-3d__obj{transition:none;}' +
      '.karva-3d__face{position:absolute;backface-visibility:hidden;-webkit-backface-visibility:hidden;}' +
      '.karva-3d__front{background:#fff;}' +
      '.karva-3d__front img{display:block;width:100%;height:100%;object-fit:fill;pointer-events:none;-webkit-user-drag:none;}' +
      '.karva-3d__back{background:#161616;}' +
      '.karva-3d__side{background:#1c1c1c;}' +
      '.karva-3d__r{background:linear-gradient(90deg,#2b2b2b,#141414);}' +
      '.karva-3d__l{background:linear-gradient(90deg,#3a3a3a,#2a2a2a);}' +
      '.karva-3d__t{background:linear-gradient(180deg,#444,#2c2c2c);}' +
      '.karva-3d__b{background:linear-gradient(180deg,#151515,#0e0e0e);}' +
      '.karva-3d__caption{font-size:12px;color:#555;text-align:center;}' +
      '.karva-zoom-btn{display:none;position:absolute;right:12px;bottom:12px;z-index:6;align-items:center;gap:6px;padding:7px 11px;' +
      'border:1px solid #202020;border-radius:999px;background:rgba(255,255,255,.92);color:#202020;font-size:13px;line-height:1;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.12);}' +
      '.karva-zoom-btn:hover{background:#202020;color:#fff;}' +
      '#karva-zoom{position:fixed;inset:0;z-index:2147483647;background:rgba(18,18,18,.94);}' +
      '#karva-zoom .kz-stage{position:absolute;inset:0;overflow:hidden;touch-action:none;cursor:zoom-in;user-select:none;-webkit-user-select:none;}' +
      '#karva-zoom .kz-stage.is-zoomed{cursor:grab;}' +
      '#karva-zoom .kz-stage img{position:absolute;left:0;top:0;max-width:none!important;width:auto;height:auto;transform-origin:0 0;will-change:transform;pointer-events:none;box-shadow:0 6px 30px rgba(0,0,0,.5);}' +
      '#karva-zoom .kz-close{position:absolute;top:14px;right:14px;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#202020;font-size:26px;line-height:44px;padding:0;cursor:pointer;}' +
      '#karva-zoom .kz-bar{position:absolute;left:50%;top:14px;transform:translateX(-50%);display:flex;border-radius:999px;overflow:hidden;background:#fff;box-shadow:0 2px 10px rgba(0,0,0,.3);}' +
      '#karva-zoom .kz-bar button{border:0;background:#fff;color:#202020;padding:10px 16px;font-size:15px;cursor:pointer;min-width:44px;}' +
      '#karva-zoom .kz-bar button+button{border-left:1px solid #e3e3e3;}' +
      '#karva-zoom .kz-hint{position:absolute;left:0;right:0;top:66px;text-align:center;color:rgba(255,255,255,.8);font-size:12px;pointer-events:none;text-shadow:0 1px 3px rgba(0,0,0,.8);}' +
      '.karva-detail-hint{display:none;margin-top:10px;font-size:13px;line-height:1.5;color:#444;}' +
      '.karva-detail-hint strong{color:#202020;}' +
      '.karva-help{flex-shrink:0;margin:16px 0 4px!important;padding:12px 14px!important;border:1px solid #d6d1c8!important;border-radius:6px!important;background:#faf8f4!important;font-size:13.5px;line-height:1.5;color:#444;}' +
      '.karva-help__text{margin:0 0 10px!important;}' +
      '.karva-help__text strong{color:#202020;}' +
      '.karva-help__actions{display:flex;flex-wrap:wrap;gap:8px;}' +
      '.karva-help__btn{display:inline-flex;align-items:center;gap:6px;padding:9px 14px!important;min-height:36px;box-sizing:border-box;border:1px solid #202020;border-radius:999px;background:#fff;color:#202020!important;font-size:13px;line-height:1;text-decoration:none!important;}' +
      '.karva-help__btn:hover{background:#202020;color:#fff!important;}' +
      '.karva-help__btn--wa{background:#25d366;border-color:#25d366;color:#fff!important;}' +
      '.karva-help__btn--wa:hover{background:#1ebe5b;border-color:#1ebe5b;}' +
      '.karva-room__caption{font-size:12px;color:#555;text-align:center;}';
    var st = document.createElement('style');
    st.id = 'karva-extras-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function refresh() {
    var size = currentSize();
    renderPresets(size);
    renderHint(size);
    renderDetailHint(size);
    renderRoom(size);
    renderSide(size);
    render3d(size);
    renderZoomBtn();
    fixHelpGap();
  }

  function init() {
    var price = byId('halftone-price-display');
    if (!price) { setTimeout(init, 200); return; }

    injectStyles();
    setupOptimizeChoice();
    setupMountChoice();
    setupHelp();
    setupRoomView();
    hookRenderer();

    // Der Konfigurator schreibt bei jeder Größenänderung den Preis neu -> danach aktualisieren
    new MutationObserver(function () { setTimeout(refresh, 0); applyDot(); scheduleSmooth(150); })
      .observe(price, { childList: true, characterData: true, subtree: true });

    // Bildwechsel (has-image) beobachten
    var placeholder = document.querySelector('.halftone-image-placeholder');
    if (placeholder) {
      new MutationObserver(function () {
        invalidateSnaps();
        setTimeout(refresh, 300);
      }).observe(placeholder, { attributes: true, attributeFilter: ['class'] });
    }

    // Bei neuem Foto (gleiche Klasse bleibt) Raum-Snapshot nach dem Rendern erneuern
    var fileInput = byId('source_file');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        setTimeout(function () {
          invalidateSnaps();
          refresh();
        }, 1500);
      });
    }

    document.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('[data-kv-custom]') : null;
      if (c) {
        e.preventDefault();
        var m = sizeModule();
        if (m) m.classList.toggle('kv-custom-open');
        var wi = byId('custom-width');
        if (m && m.classList.contains('kv-custom-open') && wi) wi.focus();
        return;
      }
      var t = e.target && e.target.closest ? e.target.closest('.karva-size-preset, .karva-tier-hint__link') : null;
      if (!t) return;
      e.preventDefault();
      if (t.classList.contains('karva-size-preset')) {
        var mm = sizeModule();
        if (mm) mm.classList.remove('kv-custom-open');
      }
      setSize(parseFloat(t.getAttribute('data-w')), parseFloat(t.getAttribute('data-h')));
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
